// extracted by mini-css-extract-plugin
export default {"wrapper":"tZ-z","availablePromoMessagesLabel":"uZ-z","promoMessageList":"vZ-z","promoMessage":"wZ-z","appliedPromoMessage":"xZ-z","promoMessageAmount":"yZ-z"};